import axios from 'axios';
// import Vue from 'vue';
import { MessageBox, Message } from 'element-ui';

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    config.headers['X-Token'] = 'token';
    config.headers['Content-type'] = 'application/json';
    if (config.url.indexOf('/api/upload') !== -1) {
      config.headers['Content-type'] = 'multipart/form-data';
      console.log(config, 'axios config==');
    }

    // if (store.getters.token) {
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    //   config.headers['X-Token'] = getToken();
    // }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;

    // if the custom code is not 20000, it is judged as an error.
    if (res) {
      console.log(res, 'responense--');
      if (res.code === 500 && res.NotLogin) { // 登录超时
        Message({
          message: '登录超时，请重新登录',
          type: 'error',
          duration: 5 * 1000
        });
        localStorage.clear();
        window.location.href = '/login';
      }
      if (res.errno === -1) {
        Message({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        });
      }
      return res;
    } else {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      });

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          // store.dispatch('user/resetToken').then(() => {
          //   location.reload();
          // });
        });
      }
      return Promise.reject(new Error(res.message || 'Error'));
    }
  },
  error => {
    console.log('err' + error); // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/common/axiosPlugin.js